module.exports = __webpack_public_path__ + "img/logo.cce71ba9.png";